const { DEFAULT_ROLE_PERMISSIONS_CLIENT } = require('./clientPermissions');
const { DEFAULT_ROLE_PERMISSIONS } = require('./defaultPermissions');

const getPermissionsAndAccess = (roles = [], permissionOverrides = {}) => {
  const allPermissions = structuredClone(permissionOverrides);
  for (const role of roles) {
    const rolePermissions = DEFAULT_ROLE_PERMISSIONS[role] || DEFAULT_ROLE_PERMISSIONS_CLIENT[role];
    if (!rolePermissions) continue;
    for (const [permission, access] of Object.entries(rolePermissions)) {
      allPermissions[permission] = access;
    }
  }
  return allPermissions;
};

module.exports = getPermissionsAndAccess;
